import { FieldConfig } from "../../../SetupFormGenerator/types";
import {
  DecoratedMessageWithLinkDisplayType,
  DecoratedMessageWithLinkType,
} from "pages/employer-of-record/components/MessageWithLink/types";
import { DEFAULT_PAYMENT_SETTINGS_FIELDS } from "../DEFAULT/constants";

export enum TaxableBenefits {
  CAR = "Car",
  TRAVEL_ROOM_AND_BOARD = "Travel, room and board",
  NONCASH_GIFT_AND_AWARDS = "Non-cash gifts & awards",
  CHILD_CARE = "Child care",
  EDUCATION = "Education",
  MEDICAL_INSURANCE = "Medical insurance",
  MOVING = "Moving",
  RECREATIONAL_FACILITIES_AND_DUES = "Recreational facilities & dues",
}

export const TAXABLEBENFITSVALUES = Object.values(TaxableBenefits);

export const TaxableBenefitsTypeMessage: {
  [key: string]: DecoratedMessageWithLinkType;
} = {
  [TaxableBenefits.NONCASH_GIFT_AND_AWARDS]: {
    text: "The maximum value to be tax-exempt is $500.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
} as const;

export const TAXABLEBENEFITSLINK =
  "https://www.canada.ca/en/revenue-agency/services/tax/businesses/topics/payroll/benefits-allowances.html";

export const PAYMENT_SETTINGS_FIELDS: FieldConfig[] =
  DEFAULT_PAYMENT_SETTINGS_FIELDS;
